import { REQUEST_STATUS } from 'redux/ducks/publisherRequests';

interface Request {
  status: string;
}

export default function omitDeclinedRequests<T extends Request>(requests: T[]) {
  return requests.filter((r) => r.status !== REQUEST_STATUS.DECLINED);
}
